import {GeomObject} from "./geom-object";

/*
 View peers.
 Views are defined in the gview3,free_crystal_ball3, and active_view
 elements of the cg3 documents.
 They refer to transfo3 elements.
 They also refer to predefined views in app-config/etc/views.cg3

 Maybe a solution is to be able to use gview3.cpp (if decoupled of opengl)
 as well as free-crystal-ball3.cpp
 and calculate the image of elementary objects so as to conclude
 camera information for BabylonJS.

 */

class GView extends GeomObject {
    constructor (input) {
        if (typeof (input) === "number") {
            super(input);
            this.x = super.readAtt("x", 100, null);
            this.y = super.readAtt("y", 100, null);
            this.height = 0 + super.readAtt("height", 100, null);
            this.width = 0 + super.readAtt("width", 100, null);
        }
        else {
            super(0);

            let count = input.childElementCount;
            this.objects = {};
            for (let i = 0; i < count; i++) {
                const elt = input.children[i];
                this[elt.localName] = elt.textContent;
            }
        }
    }
}

export {GView}